module.exports = __webpack_public_path__ + "img/66F_รูปหน้าคน-ผู้ชาย.ff631e7c.png";